module.exports = __webpack_public_path__ + "static/media/free-underline-teal.a13664cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/free-underline-teal.svg
// module id = 1674
// module chunks = 71